module.exports = __webpack_public_path__ + "img/fundingResolutionLogoCorner.0f1dc77b.svg";